import { FC } from 'react';

import Icon from './image.svg';

export const MetaMaskLogo: FC = () => <img src={Icon} alt="metamask logo" />;
